import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import { Check } from "lucide-react";

const NEON = "#E3FF00";

export default function SponsorForm() {
  const { id } = useParams();
  const [sp, setSp] = useState(null);
  const [ans, setAns] = useState({});
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get(`/public/sponsors/${id}`).then(({ data }) => setSp(data)).catch(() => setErr(true));
  }, [id]);

  const inp = "w-full bg-white border border-neutral-300 rounded-lg px-3.5 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#E3FF00]";

  if (err) return <div className="min-h-screen grid place-items-center bg-[#FDFDFC] p-6"><p className="text-neutral-600">Modulo non disponibile.</p></div>;
  if (!sp) return null;

  const submit = async () => {
    for (const fld of sp.form_fields || []) {
      if (fld.required && !String(ans[fld.label] || "").trim()) return toast.error(`Compila: ${fld.label}`);
    }
    setSaving(true);
    try { await api.post(`/public/sponsors/${id}/submit`, { answers: ans }); setSent(true); }
    catch (e) { toast.error(e?.response?.data?.detail || "Invio non riuscito"); setSaving(false); }
  };

  return (
    <div className="min-h-screen bg-[#FDFDFC] py-10 px-5" data-testid="sponsor-form-page">
      <div className="max-w-lg mx-auto bg-white rounded-2xl border border-neutral-200 shadow-xl p-7">
        {sp.logo_url && <img src={sp.logo_url} alt={sp.name} className="h-16 object-contain mb-5" />}
        <h1 className="font-display text-2xl font-extrabold text-neutral-900">{sp.title || sp.name}</h1>
        {sp.description && <p className="text-neutral-600 mt-3 leading-relaxed whitespace-pre-line">{sp.description}</p>}
        {sent ? (
          <div className="text-center py-8 space-y-4 mt-4" data-testid="sponsor-form-success">
            <div className="h-16 w-16 rounded-2xl grid place-items-center mx-auto" style={{ backgroundColor: NEON }}><Check className="h-8 w-8 text-neutral-900" /></div>
            <h2 className="font-display text-xl font-bold text-neutral-900">Grazie! Richiesta inviata.</h2>
            <p className="text-sm text-neutral-600">Abbiamo ricevuto i tuoi dati, ti ricontatteremo presto.</p>
          </div>
        ) : (
          <div className="space-y-3 mt-6">
            {(sp.form_fields || []).map((fld, i) => (
              <div key={i}>
                <label className="text-sm font-medium text-neutral-800 mb-1 block">{fld.label}{fld.required && <span className="text-rose-500"> *</span>}</label>
                {fld.type === "textarea"
                  ? <textarea className={inp + " min-h-24"} value={ans[fld.label] || ""} onChange={(e) => setAns({ ...ans, [fld.label]: e.target.value })} data-testid={`sponsor-field-${i}`} />
                  : fld.type === "select"
                    ? <select className={inp} value={ans[fld.label] || ""} onChange={(e) => setAns({ ...ans, [fld.label]: e.target.value })} data-testid={`sponsor-field-${i}`}><option value="">Seleziona...</option>{(fld.options || []).map((o, j) => <option key={j} value={o}>{o}</option>)}</select>
                    : <input type={fld.type === "email" ? "email" : fld.type === "tel" ? "tel" : "text"} className={inp} value={ans[fld.label] || ""} onChange={(e) => setAns({ ...ans, [fld.label]: e.target.value })} data-testid={`sponsor-field-${i}`} />}
              </div>
            ))}
            {(sp.form_fields || []).length === 0 && <p className="text-sm text-neutral-500">Questo modulo non ha ancora domande configurate.</p>}
            <button onClick={submit} disabled={saving} className="w-full bg-[#E3FF00] text-neutral-900 font-semibold py-3 rounded-lg hover:brightness-95 disabled:opacity-60" data-testid="sponsor-form-submit">{saving ? "Invio..." : "Invia"}</button>
          </div>
        )}
      </div>
    </div>
  );
}
